import dayjs from 'dayjs';
import type { TestConfig } from 'yup';

/**
 * Yup test asserting an end-date field falls strictly after a sibling start-date
 * field on the same form object.
 */
export const createAfterStartDateTest = (
  startDateField: string,
  message = 'End date must be after start date',
): TestConfig<string | undefined> => ({
  name: 'after-start-date',
  message,
  test(endDate) {
    const startDate = (this.parent as Record<string, unknown>)[startDateField] as
      string | undefined;
    if (!startDate || !endDate) {
      return true;
    }
    if (!dayjs(startDate).isValid() || !dayjs(endDate).isValid()) {
      return true;
    }
    return dayjs(endDate).isAfter(dayjs(startDate));
  },
});

/**
 * Yup test asserting that an end-date field is at least `minMonths` after a
 * sibling start-date field. The minimum is parameterized so the same helper can
 * back different lease-length policies.
 */
export const createMinMonthsAfterStartDateTest = (
  startDateField: string,
  minMonths: number,
  message = `End date must be at least ${minMonths} months after start date`,
): TestConfig<string | undefined> => ({
  name: `${minMonths}-months-after-start-date`,
  message,
  test(endDate) {
    if (!endDate) {
      return true;
    }
    const startDate = (this.parent as Record<string, unknown>)[startDateField] as
      string | undefined;
    return dayjs(endDate).isAfter(dayjs(startDate).add(minMonths, 'month'));
  },
});
